export default __webpack_public_path__ + "static/media/moving-car.ecffb284.svg";